import ApiUrlMixin from './ApiUrlMixin'
import RequestMixin from './RequestMixin'
import RequestParamsMixin from './RequestParamsMixin'
import { BIND_TYPE, COUNTRY_PHONE_CODE, DEFAULT_LOCALE } from '@/constants'
import { EVENT } from '@/constants/event'

export default {
  mixins: [RequestParamsMixin, RequestMixin, ApiUrlMixin],
  data () {
    return {
      bindPhone: this.$route.params.type === BIND_TYPE.PHONE,
      bindEmail: this.$route.params.type === BIND_TYPE.EMAIL,
      captchaToken: ''
    }
  },
  methods: {
    getHeaderText () {
      return this.bindPhone ? this.$t('title__bind_phone_number') : this.$t('title__bind_email')
    },
    getDisplayPhoneNumber () {
      let {phoneCountry, phone} = this.$store.state.bind
      return (phoneCountry && phone && `+${phoneCountry} ${phone}`) || decodeURI(this.$route.query.data)
    },
    getDisplayEmailAddress () {
      let email = this.$store.state.bind.email || decodeURI(this.$route.query.data)
      let at = email.indexOf('@')
      return email.substring(0, Math.min(3, at)) + '****' + email.substring(at)
    },
    updatePhoneNumber (packedData) {
      this.$store.commit('bind/updatePhone', {
        phoneCountry: packedData.dropdown,
        phoneNumber: packedData.input
      })
    },
    updateEmailAddress (email) {
      this.$store.commit('bind/updateEmail', {
        email: email
      })
    },

    validateEmail (email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },

    validatePhoneNumber (countryNumber, phoneNumber) {
      return /^\d{1,3}$/.test(countryNumber) && /^\d{5,20}$/.test(phoneNumber)
    },

    validatePhoneOtp (otp) {
      return /^\d{6}$/.test(otp)
    },

    validateEmailCode (code) {
      return /^\d{8}$/.test(code)
    },

    submitBindPhoneInit () {
      if (this.validatePhoneNumber(this.$store.state.bind.phoneCountry, this.$store.state.bind.phone)) {
        this.request('post', this.getBindApiUrl('phone', 'init'), {
          ...this.$store.getters['bind/requestParams'],
          phone: this.$store.getters['bind/fullPhoneNumber'],
          captcha_token: this.captchaToken
        }, () => {
          this.$store.commit('bind/setVerifyTimestamp')
          this.redirectToBindStep('verify')
        })
      } else {
        this.$emit(EVENT.SHOW_WARNING, this.$t('error__invalid_phone_number'))
      }
    },
    submitBindEmailInit () {
      let email = String(this.$store.getters['bind/emailAddress']).toLowerCase()
      if (this.validateEmail(email)) {
        this.request('post', this.getBindApiUrl('email', 'init'), {
          ...this.$store.getters['bind/requestParams'],
          email: email
        }, () => {
          this.$store.commit('bind/setVerifyTimestamp')
          this.redirectToBindStep('verify')
        })
      } else {
        this.$emit(EVENT.SHOW_WARNING, this.$t('error__invalid_email_format'))
      }
    },

    redirectToBindStep (step) {
      let extra = {}
      extra.data = encodeURI(this.bindPhone ? this.getDisplayPhoneNumber() : this.getDisplayEmailAddress())
      this.redirectWithParams(`/bind/${this.$route.params.type}/${step}`, extra)
    }
  },
  computed: {
    countryCodeList () {
      return COUNTRY_PHONE_CODE[(this.$store.getters['bind/requestParams'].locale || DEFAULT_LOCALE).slice(-2)]
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/bind/mixins/BindBaseMixin.js